import {Component, OnInit, HostListener} from '@angular/core';
import {CatalogManageService} from '../catalog-manage/catalog-manage.service';
import {ToasterService} from 'angular2-toaster';
import {DPAccountService} from '../../portalv1/dp-accounts.service';
import {CatalogService} from '../catalog-api/catalog.service';
import {AssetService} from '../../shared/asset.service';
import {UserService} from '../../user/user.service';
import {DPSubscriptionService, DPUserService} from '../../portalv1';
import {CompleterService, CompleterData} from 'ng2-completer';
import {DatahealthService} from '../datahealth/datahealth.service';
import {ImageUpdateService} from '../image-update/image-update.service';
import {ActivatedRoute} from '@angular/router';
// tslint:disable-next-line:import-blacklist
import {Subject} from 'rxjs';
import CommonUtils from '../../shared/common.util';
import {ImageUpdateRequest} from '../catalog-api/model/image-update-request';
// tslint:disable-next-line:import-blacklist
import {Subscription} from 'rxjs';
import {TimerObservable} from 'rxjs/observable/TimerObservable';

declare var jQuery: any;

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'catalog-search',
    templateUrl: 'catalog-search.component.html',
    styleUrls: ['catalog-search.component.scss'],
})
export class CatalogSearchComponent implements OnInit {
    subscriptionTitles;
    catalogTitles;
    DEFAULT_TITLE_LIMIT = 25;
    activeView = 'catalog';
    data: any = {};
    titleSearchStr;
    titleDataService: CompleterData;
    accountDataService: CompleterData;
    busyLoading = false;
    collapsed = {byAccount: false, byStatus: true};
    titleLimit;
    currentTitles = [];
    isExternalUser = true;
    isHelpDeskAdmin = false;
    updateRequests: ImageUpdateRequest[];
    // Set default selectdStatus to all so that the view by works.
    selectedStatus = {id: 0, name: 'all'};
    selectedLabel = {
        name: 'All Titles',
        id: 101
    };

    // Parameter for catalog-manage component
    selectedShow;

    private subject: Subject<string> = new Subject();

    // Check the claimed titles every if on the all titles missing filter
    private claimTitlesSubscription: Subscription;

    constructor(private catalogManagerService: CatalogManageService,
                private toasterService: ToasterService,
                private accountService: DPAccountService,
                private catalogService: CatalogService,
                public assetService: AssetService,
                private userService: UserService,
                private subscriptionService: DPSubscriptionService,
                private completerService: CompleterService,
                private datahealthService: DatahealthService,
                private dpUserService: DPUserService,
                private imageUpdateService: ImageUpdateService,
                private route: ActivatedRoute) {

    }

    ngOnInit(): void {
        this.subject.debounceTime(500).subscribe(searchTextValue => {
            this.filterSearch(searchTextValue);
        });

        if (localStorage.getItem('is_data_api_user') === 'true') {
            this.isExternalUser = false;
            this.dpUserService.getOwnUser().then(user => {
                if (
                    user.roles &&
                    user.roles.findIndex(x => x === 'Helpdesk Admin') > -1
                ) {
                    this.isHelpDeskAdmin = true;
                }
            });
        }

        this.busyLoading = true;
        this.resetTitleLimit();
        // this.catalogService
        // 	.getAllCatalogue()
        // 	.then(res => {
        // 		this.catalogTitles = res.metadata;
        // 		this.currentTitles = this.catalogTitles;
        // 		this.busyLoading = false;
        // 		// Commented this out as it is not used and lags out the helpdesk.
        // 		// for internal use
        // 		// if (this.isExternalUser === false) {
        // 		//   this.busyLoading = true;
        // 		//   this.getAllAccounts();
        // 		//   this.prepareSubscriptionTitles();
        // 		// }
        // 	})
        // 	.catch(error => {
        // 		// this.errorHandler(error)
        // });
        const claimTitlesTimer = TimerObservable.create(30000, 30000);
        this.claimTitlesSubscription = claimTitlesTimer.subscribe(() => {
            if (this.selectedLabel.name === 'All Titles Missing Images') {
                this.getAndDisplayClaimedTitles();
            }
        });
    }

  // tslint:disable-next-line:use-life-cycle-interface
    ngOnDestroy() {
        this.claimTitlesSubscription.unsubscribe();
    }

    prepareSubscriptionTitles() {
        this.subscriptionService.getAllTitles()
            .then(res => {
                // Titles that have info about which account

                this.subscriptionTitles = res.subscriptions.titles;

                if (this.catalogTitles) {
                    this.catalogTitles.forEach(element => {
                        const index = this.subscriptionTitles.findIndex(x => x.parrot_id === element.parrot_id);
                        if (index > -1) {
                            const findObject = this.subscriptionTitles[index];
                            element.accounts = findObject.accounts;
                        }
                    });
                    this.currentTitles = this.catalogTitles;
                }

            });

    }

    getAllAccounts() {
        this.busyLoading = true;
        this.accountService.getSubscriptionUserAccounts().then(res => {
            if (!res || !res.user_accounts) {
                this.toasterService.pop('error', 'Catalog', 'Failed to load list of customers');
                return;
            }
            this.data = {};
            const tableData = [];
            res.user_accounts.forEach(($account, index) => {
                const rowData: any = {};
                rowData.id = $account.account_id;
                rowData.name = $account.account_name;
                rowData.customer = $account.customer;
                rowData.status = $account.status;
                rowData.access_level = $account.access_level;
                rowData.items = rowData.items || [];
                rowData.color = this.getColorForLabel(rowData.name);
                $account.rowData = rowData;
                tableData.push(rowData);
            });
            this.data.masterTableData = tableData;
            this.data.masterTableByStatus = [
                {id: 0, name: 'all'},
                {id: 1, name: 'cust_ready'},
                {id: 2, name: 'onboarded'},
                {id: 3, name: 'harvesting'},
                {id: 4, name: 'pending'}
            ];
            if (!this.selectedStatus) {
                this.selectedStatus = this.data.masterTableByStatus[0];
            }
            this.accountDataService = this.completerService.local(this.data.masterTableData, 'name', 'name');

            this.busyLoading = false;

        });
    }

    filterSearch(term: string) {
        this.titleSearchStr = term;
        if (this.titleSearchStr && this.titleSearchStr !== '' && this.selectedLabel.name !== 'All Pending Mappings') {
            this.updateTitlesList().then(() => {
                const recentCurrentTitles = this.currentTitles;
                this.currentTitles = recentCurrentTitles.filter(x => x.title.toLowerCase().includes(this.titleSearchStr.toLowerCase()));

                if (this.currentTitles.length < 1) {
                    this.currentTitles = recentCurrentTitles.filter(x => x.parrot_id.toLowerCase() === this.titleSearchStr.toLowerCase());

                    if (this.currentTitles.length < 1 && this.selectedLabel.name === 'All Titles') {
                        this.esSearch();
                    }
                }
            });
        } else if (this.titleSearchStr === '') {
            this.updateTitlesList();
        }
    }

    updateTitlesList() {
        return new Promise((resolve, reject) => {
            this.busyLoading = true;
            if (this.selectedLabel.name === 'All Titles') {
                this.currentTitles = this.catalogTitles;
                if (this.selectedStatus) {
                    this.handleStatus();
                }
                this.busyLoading = false;
                resolve();
            } else if (this.selectedLabel.name === 'All Pending Mappings') {
                this.datahealthService
                    .getMappingRequestTitleByState('pending', undefined)
                    .then(res => {
                        const mappingTitleIdList = [];
                      // tslint:disable-next-line:forin
                        for (const k in res) {
                            mappingTitleIdList.push(k);
                        }
                        this.currentTitles = this.catalogTitles.filter(x => {
                            const index = mappingTitleIdList.findIndex(y => y === x.parrot_id);
                            if (index > -1) {
                                return true;
                            } else {
                              // tslint:disable-next-line:no-unused-expression
                                false;
                            }
                        });
                        this.handleStatus();
                        this.busyLoading = false;
                        resolve();
                    })
                    .catch(error => {
                        reject();
                    });
            } else if (this.selectedLabel.name === 'All Pending Images') {
                // Get the parrot_id's of all the titles that have pending images
                // Filter the catalog titles to only have titles with pending images
                // and set the result to currentTitles
                this.imageUpdateService
                    .getImageUpdateRequest(null, ['PENDING', 'PROD_QA'])
                    .then(res => {
                        const updateRequests: ImageUpdateRequest[] = res['update_requests'];
                        this.updateRequests = updateRequests;
                        this.currentTitles = this.catalogTitles.filter(catalogTitle => {
                            const index = updateRequests.findIndex(updateRequest => updateRequest.title_id === catalogTitle.parrot_id);
                            if (index > -1) {
                                return true;
                            } else {
                                return false;
                            }
                        });
                        this.handleStatus();
                        this.getAndDisplayProdQATitles()
                            // tslint:disable-next-line:no-shadowed-variable
                            .then((res) => {
                                this.busyLoading = false;
                                resolve();
                            });
                    });
            } else if (this.selectedLabel.name === 'All Titles Missing Images') {
                // We will be sorting by entry start_date.
                this.catalogService.getCatalogMissingImages()
                    .then((res) => {
                        const missingImagesResponse = res;
                        this.currentTitles = missingImagesResponse.metadata.filter((title) => {
                            if (title.data.start_date) {
                                return true;
                            } else {
                                return false;
                            }
                        });

                        if (this.selectedStatus) {
                            this.handleStatus();
                        }

                        this.getAndDisplayClaimedTitles()
                            .then(() => {
                                this.busyLoading = false;
                                resolve();
                            });
                    })
                    .catch((err) => {
                        console.error('Error loading titles missing images: ', err.toString());
                        reject();
                    });
            } else if (this.catalogTitles) {
                this.currentTitles = this.catalogTitles.filter((title) => {
                    return this.hasAccount(title.accounts, this.selectedLabel.name);
                });
                this.handleStatus();
                this.busyLoading = false;
                resolve();
            } else {
                this.currentTitles = [];
                this.busyLoading = false;
                resolve();
            }
        });
    }

    esSearch() {
        if (this.titleSearchStr && this.titleSearchStr !== '' && this.currentTitles.length === 0) {
            this.catalogService.callEsProxy(this.titleSearchStr)
                .then(res => {
                        const hits = res.hits.hits;
                        if (hits) {
                            this.currentTitles = this.catalogTitles.filter(x => {
                                if (hits.findIndex(y => y._id === x.parrot_id) > -1) {
                                    return true;
                                } else {
                                    return false;
                                }
                            });
                        }
                    }
                )
                .catch(error => {
                });
        }
    }

    selectLabel(label) {
        this.selectedLabel = label;

        if (label === 'All Titles') {
            this.selectedLabel = {
                name: label,
                id: 101
            };
        } else if (label === 'All Pending Mappings') {
            this.selectedLabel = {
                name: label,
                id: 999
            };
        } else if (label === 'All Pending Images') {
            this.selectedLabel = {
                name: label,
                id: 998
            };
        } else if (label === 'All Titles Missing Images') {
            this.selectedLabel = {
                name: label,
                id: 997
            };
        }

        this.updateTitlesList();
    }

    selectTitlesByAccount(account) {
        this.data.masterTableData.forEach(element => {
            if (element.name === account) {
                this.selectLabel(element);
                return;
            }
        });
    }

    showsByStatus(status) {
        this.selectedStatus = status;

        this.updateTitlesList();
    }

    @HostListener('scroll', ['$event'])
    onScroll($event) {
        this.titleLimit += 10;
    }

    resetTitleLimit() {
        this.titleLimit = this.DEFAULT_TITLE_LIMIT;
    }

    getColorForLabel(labelStr) {
        return CommonUtils.getColorForLabel(labelStr);
    }


    handleStatus() {
        if (this.selectedStatus.name !== 'all') {
            this.currentTitles = this.currentTitles.filter(x => {
                if (x && x.internal_data && x.internal_data.data_state) {
                    return x.internal_data.data_state === this.selectedStatus.name;
                } else {
                    return false;
                }
            });
        }
    }

    hasAccount(accounts, accountToFind) {
        if (!accounts || accountToFind === 'All Titles') {
            return false;
        }
        const filteredAccount = accounts.filter((account) => {
            return account === accountToFind;
        });
        return (filteredAccount !== undefined && filteredAccount.length > 0);
    }

    onKeyUp(searchTextValue: string) {
        this.subject.next(searchTextValue);
    }

    showDetails(show) {
        this.selectedShow = show;
    }

    getAndDisplayProdQATitles() {
        return new Promise((resolve, reject) => {
            this.imageUpdateService.getImageUpdateRequest(null, ['PROD_QA']).then((res) => {
                const claimedTitles = res.update_requests;

                this.currentTitles = this.currentTitles.map((item) => {
                    const foundTitle = claimedTitles.find(claimedTitlesItem => claimedTitlesItem.title_id === item.parrot_id);
                    if (foundTitle) {
                        item.prodQA = true;
                    }
                    return item;
                });
                resolve();
            })
                .catch((err) => {
                    console.error('Error getting claimed images: ' + err.toString());
                    resolve();
                });
        });
    }

    getAndDisplayClaimedTitles() {
        return new Promise((resolve, reject) => {
            this.imageUpdateService.getImageUpdateRequest(null, ['CLAIMED']).then((res) => {
                const claimedTitles = res.update_requests;

                this.currentTitles = this.currentTitles.map((item) => {
                    const foundTitle = claimedTitles.find(claimedTitlesItem => claimedTitlesItem.title_id === item.parrot_id);
                    if (foundTitle) {
                        item.claimed = true;
                    }
                    return item;
                });
                resolve();
            })
                .catch((err) => {
                    console.error('Error getting claimed images: ' + err.toString());
                    resolve();
                });
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/catalogue/catalog-search/catalog-search.component.ts